import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as action from '../../redux/actions';
import NumberFormat from 'react-number-format';
import { IMG_URL } from '../../config/apiURL';
import ProductModal from './product-modal';
import ModalPortal from '../../portals/ModalPortal';

class Item extends Component {
   constructor(props) {
      super(props);
      this.state = { showModal: false };
   }

   addCarrito(item) {
      this.props.dispatch(action.add_carrito(item));
      addMessage();
      function addMessage() {
         let popup = document.getElementById('popup');
         popup.classList.remove('hidden');
         setTimeout(function () {
            popup.classList.add('hidden');
         }, 2500);
      }
   }

   componentDidMount() {
      document.addEventListener('keydown', this.handleKeyDown);
   }

   componentWillUnmount() {
      document.removeEventListener('keydown', this.handleKeyDown);
   }

   handleShowModal() {
      this.setState({ showModal: !this.state.showModal });
   }

   handleKeyDown = event => {
      if (event.key === 'Escape' && this.state.showModal) {
         this.handleShowModal();
      }
   };

   render() {
      return (
         <div className="justify-center" style={{ padding: '30px 0' }}>
            <div className="promotion-item">
               <div className="column">
                  <div className="promotion-image">
                     <img
                        className="product-image"
                        src={
                           IMG_URL +
                           '/catalogo/obtenerimagenes?id_producto=' +
                           this.props.item.id_producto
                        }
                        alt="Producto en Catálogo"
                        title="Producto en Catálogo"
                        onClick={this.handleShowModal.bind(this)}
                     />
                  </div>
                  <div className="white-space-8"></div>
                  <div className="promotion-info column">
                     <div className="promotion-name justify-center">
                        <h5 className="text-center">
                           <a
                              className="product-name"
                              onClick={this.handleShowModal.bind(this)}
                           >
                              {this.props.item.Producto}
                           </a>
                        </h5>
                     </div>
                     <div className="white-space-8"></div>
                     <div className="btn-cart-div justify-between align-center color-lightGray">
                        <div className="promotion-price justify-center align-center">
                           <h4 className="color-white">
                              <NumberFormat
                                 decimalScale={2}
                                 displayType="text"
                                 fixedDecimalScale={true}
                                 prefix="$"
                                 value={this.props.item.Precio}
                                 thousandSeparator={true}
                              />
                              &nbsp;
                           </h4>
                           <h5 className="color-orange discount">
                              <NumberFormat
                                 decimalScale={2}
                                 displayType="text"
                                 fixedDecimalScale={true}
                                 prefix="$"
                                 thousandSeparator={true}
                              />
                           </h5>
                        </div>
                        <a
                           className="btn-cart link"
                           onClick={this.addCarrito.bind(this, this.props.item)}
                        >
                           <i className="fas fa-cart-plus"></i>
                        </a>
                     </div>
                  </div>
                  <div className="white-space-8"></div>
               </div>
            </div>

            {this.state.showModal && (
               <ModalPortal>
                  <ProductModal
                     product={this.props.item}
                     onClose={this.handleShowModal.bind(this)}
                     onAddProduct={this.addCarrito.bind(this, this.props.item)}
                  />
               </ModalPortal>
            )}
         </div>
      );
   }
}

function mapStateToProps(state) {
   return {
      auth: state.auth,
   };
}

export default connect(mapStateToProps)(Item);



// WEBPACK FOOTER //
// ./src/components/Products/item.js